export default "__VITE_ASSET__RzkuWlX1__"